<lds-card [isClickable]="true" (click)="cardClicked()">
  <div>
    <div *ngIf="referrerArrangement; else emptyList">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-3">
          <app-summary-field
            label="Payee Name"
            [text]="referrerArrangement.payeeName"></app-summary-field>
        </div>

        <ng-container *ngIf="referrerArrangement.upfront.amount">
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Upfront Amount"
              [text]="
                referrerArrangement.upfront.amount
                  | currency : '' : 'symbol-narrow' : '1.0-0'
              "></app-summary-field>
          </div>
        </ng-container>

        <ng-container *ngIf="referrerArrangement.upfront.percent">
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Upfront Percent"
              [text]="
                referrerArrangement.upfront.percent | percent
              "></app-summary-field>
          </div>
        </ng-container>

        <ng-container *ngIf="referrerArrangement.trail">
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Trail Percent"
              [text]="referrerArrangement.trail | percent"></app-summary-field>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</lds-card>

<ng-template #emptyList>
  <p>None</p>
</ng-template>
